import { FC } from "react";

import { Button } from "@/components/atoms/buttons/Button";
import { BasicModal } from "@/components/atoms/modals/BasicModal";

interface Props {
  pageTitle: string;
  isOpen: boolean;
  closeHandler: () => void;
  handleSubmit: () => Promise<void>;
}

/**
 * 「非公開」ボタン押下時のモーダル
 * @param pageTitle 対象ページのタイトル
 * @param isOpen モーダル表示
 * @param closeHandler 「閉じる」ボタンのイベント
 * @param handleSubmit 「非公開」ボタンのイベント
 * @returns
 */
export const ConfirmPrivateModal: FC<Props> = ({
  pageTitle,
  isOpen,
  closeHandler,
  handleSubmit,
}) => {
  return (
    <BasicModal title="ページ非公開" isOpen={isOpen} close={closeHandler}>
      <div className="flex flex-col justify-center content-center p-8">
        <div>
          [{pageTitle !== "" ? pageTitle : "無題"}] を非公開にしますか？
        </div>
        <div className="flex justify-end mt-6">
          <div className="flex space-x-4">
            <Button
              label="キャンセル"
              size="sm"
              color={"cancel"}
              onClick={closeHandler}
            />
            <Button
              label="非公開"
              size="sm"
              color={"delete"}
              onClick={() => void handleSubmit()}
            />
          </div>
        </div>
      </div>
    </BasicModal>
  );
};
